import { ApiClient } from '../apiClient';
import {
  CustomPage,
  CustomPageSitemapEntry,
} from '../../types/customPage';

export class CustomPageService {
  constructor(private apiClient: ApiClient) {}

  async getPageBySlug(slug: string, lang?: string): Promise<CustomPage | null> {
    try {
      const queryParam = lang ? `?lang=${lang}` : '';
      return await this.apiClient.get<CustomPage>(`/custom-pages/pages/slug/${encodeURIComponent(slug)}${queryParam}`);
    } catch (error) {
      console.error('Error fetching custom page by slug:', error);
      return null;
    }
  }

  async getPageHreflangSlugs(slug: string): Promise<Record<string, string>> {
    try {
      return await this.apiClient.get<Record<string, string>>(`/custom-pages/pages/slug/${encodeURIComponent(slug)}/hreflang`);
    } catch (error) {
      console.error('Error fetching custom page hreflang slugs:', error);
      return {};
    }
  }

  async getPublishedSlugMaps(slugs: string[]): Promise<Record<string, Record<string, string>>> {
    const query = encodeURIComponent(slugs.join(','));
    return await this.apiClient.get<Record<string, Record<string, string>>>(
      `/custom-pages/pages/published-slugs?slugs=${query}`,
    );
  }

  // No catch: swallowing errors into [] silently drops every custom page
  // from the sitemap. The sitemap routes translate a throw into a 503.
  async getSitemapPages(): Promise<CustomPageSitemapEntry[]> {
    return await this.apiClient.get<CustomPageSitemapEntry[]>('/custom-pages/pages/sitemap');
  }
}
